import { maskCandidate, type Candidate, type MaskedCandidate } from "@vidario/domain";
import { useSyncExternalStore } from "react";

import { useIsAdmin } from "../guards/useRole";
import { anonymView } from "../platform/anonym-view";

/** True while the Anonym-Ansicht is on (#140). Only admins have it; for
 * everyone else it's always off. */
export function useAnonymView(): boolean {
  const isAdmin = useIsAdmin();
  const on = useSyncExternalStore(anonymView.subscribe, anonymView.get, () => false);
  return isAdmin && on;
}

/** The candidate as the current view shows it. */
export function useMaskedCandidate(candidate: Candidate): MaskedCandidate {
  return maskCandidate(candidate, useAnonymView());
}
